import './styles.scss';

import React from 'react';

interface Props {
  title: string;
}

const PageHeading = (props: Props) => {
  return <div className="PageHeading">{props.title}</div>;
};

export default PageHeading;
